var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6937 1C29.5874 1 30.2615 1.77328 29.9009 3.21159L25.5267 23.5489C25.221 24.9949 24.3352 25.3429 23.1123 24.6702L12.6784 17.0688C12.638 17.0402 12.605 17.0024 12.5823 16.9587C12.5595 16.915 12.5477 16.8666 12.5477 16.8175C12.5477 16.7684 12.5595 16.7199 12.5823 16.6762C12.605 16.6325 12.638 16.5948 12.6784 16.5662L22.8843 7.76082L8.76671 14.9655C8.72085 14.995 8.66878 15.0138 8.61445 15.0205C8.56012 15.0272 8.50495 15.0216 8.45314 15.0041L2.03292 13.0013C0.606201 12.5915 0.606201 11.6249 2.35432 10.9367L28.0431 1.16239C28.2468 1.06598 28.468 1.01076 28.6937 1Z",
    stroke: "#9F9F9F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.6c31cff47f7708f8c46396fa27694714.svg";
export { ForwardRef as ReactComponent };